<div class="card">
    <div class="card-body">
        <ngx-spinner name="dialogSpinner" [fullScreen]="false" type="ball-clip-rotate-multiple" size="medium">
            <p style="color: white">Loading ...</p>
        </ngx-spinner>
        <div class="row">
            <div class="col-md-12">
                <h3>Meta audience parameters</h3>
                <section>
                    <mat-button-toggle-group [(ngModel)]="newAudience" name="newAudienceSelector"
                        aria-label="New audience" (change)="onNewAudienceSelected()">
                        <mat-button-toggle value="0">Existing audience</mat-button-toggle>
                        <mat-button-toggle value="1">New audience</mat-button-toggle>
                    </mat-button-toggle-group>
                </section>
            </div>
        </div>
        <div class="row">&nbsp;</div>
        <form [formGroup]="form">
            <div class="row">
                <div class="col-md-12">
                    <h3>Direct send</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Business</mat-label>
                        <input #matAutocompleteBusinesses name="matAutocompleteBusinesses" type="text"
                            placeholder="Pick one" aria-label="Business" matInput
                            [formControl]="form.controls.businessId" [matAutocomplete]="auto"
                            (input)="filterBusinesses()" (focus)="filterBusinesses()" (click)="resetBusinessesFilter()">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                            [displayWith]="getBusinessDescription.bind(this)"
                            (optionSelected)="onBusinessChange($event)">
                            <mat-option *ngFor="let business of filteredBusinesses"
                                [value]="business.id">{{business.name}}</mat-option>
                        </mat-autocomplete>
                        <mat-error
                            *ngIf="form.controls.businessId.errors && (form.controls.businessId.dirty || form.controls.businessId.touched)">Business
                            is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-9">
                    <mat-form-field *ngIf="adAccounts.length > 0" style="width: 100%;">
                        <mat-label>Ad Account</mat-label>
                        <input #matAutocompleteAdAccounts name="matAutocompleteAdAccounts" type="text"
                            placeholder="Pick one" aria-label="Add account" matInput
                            [formControl]="form.controls.adAccountId" [matAutocomplete]="auto"
                            (input)="filterAdAccounts()" (focus)="filterAdAccounts()" (click)="resetAdAccountsFilter()">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                            [displayWith]="getAdAccountDescription.bind(this)"
                            (optionSelected)="onAdAccountChange($event)">
                            <mat-option *ngFor="let adAccount of filteredAdAccounts"
                                [value]="adAccount.accountId">{{adAccount.name}}</mat-option>
                        </mat-autocomplete>
                        <mat-error
                            *ngIf="form.controls.adAccountId.errors && (form.controls.adAccountId.dirty || form.controls.adAccountId.touched)">AdAccount
                            is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12" *ngIf="newAudience == '0'">
                    <mat-form-field *ngIf="!!form.controls.adAccountId.value && audiences.length > 0"
                        style="width: 100%;">
                        <mat-label>Audience</mat-label>
                        <input #matAutocompleteAudiences name="matAutocompleteAudiences" type="text"
                            placeholder="Pick one" aria-label="Audience" matInput
                            [formControl]="form.controls.audienceId" [matAutocomplete]="auto"
                            (input)="filterAudiences()" (focus)="filterAudiences()" (click)="resetAudiencesFilter()"
                            style="width: 100%;">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                            [displayWith]="getAudienceDescription.bind(this)"
                            (optionSelected)="onAudienceChange($event)">
                            <mat-option *ngFor="let audience of filteredAudiences" [value]="audience.id">{{audience.id}}
                                - {{audience.name}}</mat-option>
                        </mat-autocomplete>
                        <mat-error
                            *ngIf="form.controls.audienceId.errors && (form.controls.audienceId.dirty || form.controls.audienceId.touched)">Audience
                            is required</mat-error>
                    </mat-form-field>
                    <mat-error *ngIf="!!form.controls.adAccountId.value && audiences.length == 0"
                        style="width: 100%;">The Ad Account has no audiences</mat-error>
                </div>
            </div>
        </form>
    </div>
</div>